var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScienceRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 122,
    viewBox: "0 0 211 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4405 26.7145L11.0645 25L9.34991 29.3761L13.726 31.0906L15.4405 26.7145Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 76L38 56",
    stroke: "#91A7FF",
    strokeWidth: 1.8811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.12 66.0898L58 79.9998",
    stroke: "#91A7FF",
    strokeWidth: 1.8811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0095 94.2698L62.5596 87.2998",
    stroke: "#91A7FF",
    strokeWidth: 1.8811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 90.9996L43.26 85.3096",
    stroke: "#91A7FF",
    strokeWidth: 1.8811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 110L52 89",
    stroke: "#91A7FF",
    strokeWidth: 1.8811,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2594 92.3596C58.9811 92.3596 63.6194 87.7213 63.6194 81.9996C63.6194 76.278 58.9811 71.6396 53.2594 71.6396C47.5377 71.6396 42.8994 76.278 42.8994 81.9996C42.8994 87.7213 47.5377 92.3596 53.2594 92.3596Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7698 60.5298C40.9509 60.5298 43.5298 57.9509 43.5298 54.7698C43.5298 51.5886 40.9509 49.0098 37.7698 49.0098C34.5886 49.0098 32.0098 51.5886 32.0098 54.7698C32.0098 57.9509 34.5886 60.5298 37.7698 60.5298Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7795 68.6196C97.9607 68.6196 100.54 66.0408 100.54 62.8596C100.54 59.6785 97.9607 57.0996 94.7795 57.0996C91.5984 57.0996 89.0195 59.6785 89.0195 62.8596C89.0195 66.0408 91.5984 68.6196 94.7795 68.6196Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5491 103.339C79.7302 103.339 82.3091 100.76 82.3091 97.5793C82.3091 94.3982 79.7302 91.8193 76.5491 91.8193C73.3679 91.8193 70.7891 94.3982 70.7891 97.5793C70.7891 100.76 73.3679 103.339 76.5491 103.339Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.219 117.879C50.4002 117.879 52.979 115.301 52.979 112.119C52.979 108.938 50.4002 106.359 47.219 106.359C44.0378 106.359 41.459 108.938 41.459 112.119C41.459 115.301 44.0378 117.879 47.219 117.879Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19946 96.7993C9.38062 96.7993 11.9595 94.2205 11.9595 91.0393C11.9595 87.8581 9.38062 85.2793 6.19946 85.2793C3.0183 85.2793 0.439453 87.8581 0.439453 91.0393C0.439453 94.2205 3.0183 96.7993 6.19946 96.7993Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.32 12.5808C106.434 12.5808 108.96 10.0557 108.96 6.94078C108.96 3.82589 106.434 1.30078 103.32 1.30078C100.205 1.30078 97.6797 3.82589 97.6797 6.94078C97.6797 10.0557 100.205 12.5808 103.32 12.5808Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.29 52.9895C152.09 57.5995 145.24 60.3995 137.74 60.3995C121.46 60.3995 108.26 47.1995 108.26 30.9195C108.26 14.6395 121.46 1.43945 137.74 1.43945C154.02 1.43945 167.22 14.6395 167.22 30.9195C167.22 34.8895 166.44 38.6695 165.02 42.1295",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.12 19.9791C171.04 19.7791 174.84 20.5191 175.29 22.2791C176.28 26.1691 160.54 33.5491 140.12 38.7791C119.7 44.0091 102.34 45.0991 101.35 41.2091C100.92 39.5291 103.63 37.1891 108.49 34.6491",
    stroke: "#5C7CFA",
    strokeWidth: 1.1144,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.48 64.1591C174.716 64.1591 179.771 59.1044 179.771 52.8691C179.771 46.6338 174.716 41.5791 168.48 41.5791C162.245 41.5791 157.19 46.6338 157.19 52.8691C157.19 59.1044 162.245 64.1591 168.48 64.1591Z",
    fill: "#DBE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.36 59.3692C164.39 57.0992 163.39 54.4392 161.12 53.4092",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.11 57.4491C173.74 57.0091 172.27 57.7591 171.82 59.1291",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.36 50.9893C172.02 50.7493 173.17 49.2193 172.93 47.5693",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.74 46.1394C165.64 46.8994 166.98 46.7894 167.75 45.8994",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.39 19.6906C195.201 19.6906 198.29 16.6014 198.29 12.7906C198.29 8.97986 195.201 5.89062 191.39 5.89062C187.579 5.89062 184.49 8.97986 184.49 12.7906C184.49 16.6014 187.579 19.6906 191.39 19.6906Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.75 9.66016H197.04",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.49 12.1602H198.29",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.04 15.9307H185.75",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1201 45.1093C89.6651 45.1093 94.1602 40.6142 94.1602 35.0693C94.1602 29.5244 89.6651 25.0293 84.1201 25.0293C78.5752 25.0293 74.0801 29.5244 74.0801 35.0693C74.0801 40.6142 78.5752 45.1093 84.1201 45.1093Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2604 34.4092C77.4804 34.3492 77.7303 34.2892 77.9403 34.3692C78.1203 34.4392 78.2504 34.6092 78.4104 34.7192C78.6204 34.8692 78.8904 34.9192 79.1504 34.8992C79.9404 34.8492 80.5704 34.2592 81.2904 33.9492C82.0104 33.6392 83.1203 33.8292 83.2003 34.6092C83.2703 35.2392 82.6303 35.6692 82.2003 36.1392C81.3203 37.0892 80.9203 38.7692 79.6203 38.8792C79.9803 39.6192 80.6203 40.1892 81.0803 40.8692C81.5503 41.5492 81.8203 42.4892 81.3803 43.1892C81.1903 43.4892 80.9004 43.7092 80.7604 44.0292C80.7604 44.0292 79.4104 44.4192 77.1804 42.1892C74.9604 39.9592 76.1304 34.7292 77.2604 34.4092Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0305 44.3491C86.8105 44.7991 88.3104 41.6491 87.3304 40.7891C87.1204 40.6091 86.8705 40.4191 86.8405 40.1391C86.8205 39.9491 86.9205 39.7691 87.0405 39.6091C87.7105 38.7291 89.0205 38.4091 90.0205 38.8991C90.3905 39.0791 90.7505 39.3491 91.1505 39.2791C91.7205 39.1691 91.8905 38.4691 92.1105 37.9291C92.3305 37.3891 92.8905 36.3291 94.1505 36.3291C94.1505 36.3291 93.9005 42.1891 88.0305 44.3491Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0806 27.3591C75.4806 28.3691 83.1906 29.9691 85.8806 29.2291C86.3006 29.1091 86.8206 28.9891 87.1106 29.3191C87.2406 29.4691 87.2806 29.6591 87.3206 29.8491C87.4306 30.4191 87.5407 30.9891 87.6507 31.5491C87.7807 32.2491 88.2507 33.1491 88.9207 32.9091C89.2107 32.7991 89.3807 32.4991 89.5407 32.2291C90.1407 31.2591 90.7007 30.3791 91.7907 30.0491C91.7907 30.0491 91.6806 27.6991 87.2206 26.5891C82.7606 25.4791 83.8806 27.6991 82.7606 27.6991C81.6406 27.6991 78.9706 27.0091 78.0806 27.3591Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.99 11.3291C172.68 11.3291 172.43 11.0791 172.43 10.7691C172.43 8.88906 171.23 7.20906 169.45 6.58906C169.22 6.50906 169.07 6.29906 169.07 6.05906C169.07 5.81906 169.22 5.60906 169.45 5.52906C171.23 4.90906 172.43 3.22906 172.43 1.34906C172.43 1.03906 172.68 0.789062 172.99 0.789062C173.3 0.789062 173.55 1.03906 173.55 1.34906C173.55 3.22906 174.75 4.90906 176.53 5.52906C176.76 5.60906 176.91 5.81906 176.91 6.05906C176.91 6.29906 176.76 6.50906 176.53 6.58906C174.75 7.20906 173.55 8.88906 173.55 10.7691C173.55 11.0791 173.3 11.3291 172.99 11.3291Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9204 11.1896C86.6104 11.1896 86.3604 10.9396 86.3604 10.6296C86.3604 9.57961 85.6903 8.63961 84.7003 8.29961C84.4703 8.21961 84.3203 8.00961 84.3203 7.76961C84.3203 7.52961 84.4703 7.31961 84.7003 7.23961C85.6903 6.89961 86.3604 5.95961 86.3604 4.90961C86.3604 4.59961 86.6104 4.34961 86.9204 4.34961C87.2304 4.34961 87.4803 4.59961 87.4803 4.90961C87.4803 5.95961 88.1504 6.89961 89.1404 7.23961C89.3604 7.31961 89.5204 7.52961 89.5204 7.76961C89.5204 8.00961 89.3704 8.21961 89.1404 8.29961C88.1504 8.63961 87.4803 9.57961 87.4803 10.6296C87.4803 10.9396 87.2304 11.1896 86.9204 11.1896Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.27 69.7404C152.96 69.7404 152.71 69.4904 152.71 69.1804C152.71 68.1304 152.04 67.1904 151.05 66.8504C150.82 66.7704 150.67 66.5604 150.67 66.3204C150.67 66.0804 150.82 65.8704 151.05 65.7904C152.04 65.4504 152.71 64.5104 152.71 63.4604C152.71 63.1504 152.96 62.9004 153.27 62.9004C153.58 62.9004 153.83 63.1504 153.83 63.4604C153.83 64.5104 154.5 65.4504 155.49 65.7904C155.71 65.8704 155.87 66.0804 155.87 66.3204C155.87 66.5604 155.72 66.7704 155.49 66.8504C154.5 67.1904 153.83 68.1304 153.83 69.1804C153.82 69.4904 153.57 69.7404 153.27 69.7404Z",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 85.98C122.69 85.64 121.32 85.46 119.91 85.46C110.9 85.46 103.6 92.76 103.6 101.77C103.6 110.78 110.9 118.08 119.91 118.08C127.73 118.08 134.26 112.58 135.85 105.24",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.85 109.36C125.744 109.36 127.28 107.824 127.28 105.93C127.28 104.036 125.744 102.5 123.85 102.5C121.956 102.5 120.42 104.036 120.42 105.93C120.42 107.824 121.956 109.36 123.85 109.36Z",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.74 103.4L118.51 101.29",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.95 105.46L118.59 105.33",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.189 109.75L121.16 108.79",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.26 111.189L123.36 109.819",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.89 111.03L125.66 108.92",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.53 107.519L127.77 106.689",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.42 103.18L126.84 104.11",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.219 100.92L125.399 102.68",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.38 99.8896L123.32 102.47",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45 112.15C114.637 112.15 115.6 111.187 115.6 110C115.6 108.812 114.637 107.85 113.45 107.85C112.262 107.85 111.3 108.812 111.3 110C111.3 111.187 112.262 112.15 113.45 112.15Z",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.84 109.24L117.71 108.8",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.029 108.119L115.569 107.449",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.699 106.77L112.869 107.62",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89 107.89L111.58 108.42",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.39 110.37L111.26 109.93",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.67 112.44L111.7 111.8",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.979 113.869L113.38 112.189",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.259 112.96L114.619 111.93",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.119 111.309L115.449 110.909",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.69 96.7598C119.198 96.7598 120.42 95.5375 120.42 94.0298C120.42 92.5221 119.198 91.2998 117.69 91.2998C116.182 91.2998 114.96 92.5221 114.96 94.0298C114.96 95.5375 116.182 96.7598 117.69 96.7598Z",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.51 95.4893L122.59 96.7693",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.79 93.7597L121.87 93.6396",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.91 90.46L119.31 91.37",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.279 89.8496L117.429 90.9296",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.71 90.7197L115.79 91.9997",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.01 93.7197L114.51 94.0797",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8 97.0797L115.66 95.9297",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.649 98.3096L117.009 96.8096",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.81 98.4896L118.66 96.6396",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 104.309C110.149 104.309 111.08 103.378 111.08 102.229C111.08 101.081 110.149 100.149 109 100.149C107.851 100.149 106.92 101.081 106.92 102.229C106.92 103.378 107.851 104.309 109 104.309Z",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.109 100.069L111.079 98.4795",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.79 99.8593L108.689 99.0293",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.27 100.529L106.969 100.989",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.8 102.54L106.63 102.43",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.47 105.27L107.45 103.68",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.77 105.799L109.04 104.659",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.329 105.189L110.449 103.779",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.27 103.009L111.12 102.739",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.4 100.6L110.99 101.48",
    stroke: "#5C7CFA",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.009 104.74C144.999 105 144.989 105.26 144.989 105.53C144.989 114.54 152.289 121.84 161.299 121.84C170.309 121.84 177.609 114.54 177.609 105.53C177.609 96.5197 170.309 89.2197 161.299 89.2197C159.539 89.2197 157.849 89.4997 156.259 90.0097",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.79 112.151C153.42 111.931 152.98 111.811 152.52 111.811C151.13 111.811 150.01 112.931 150.01 114.321C150.01 115.711 151.13 116.831 152.52 116.831C153.52 116.831 154.39 116.241 154.79 115.391",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.28 115.57C157.666 115.57 158.79 114.446 158.79 113.06C158.79 111.674 157.666 110.55 156.28 110.55C154.893 110.55 153.77 111.674 153.77 113.06C153.77 114.446 154.893 115.57 156.28 115.57Z",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.789 113.06C160.179 113.06 161.299 111.94 161.299 110.55C161.299 109.16 160.179 108.04 158.789 108.04C157.399 108.04 156.279 109.16 156.279 110.55",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.15 111.37C161.55 111.64 162.03 111.8 162.55 111.8C163.94 111.8 165.06 110.68 165.06 109.29C165.06 107.9 163.94 106.78 162.55 106.78C161.46 106.78 160.52 107.48 160.18 108.46",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.06 109.291C166.45 109.291 167.57 108.171 167.57 106.781C167.57 105.391 166.45 104.271 165.06 104.271C163.67 104.271 162.55 105.391 162.55 106.781",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.72 104.9C167.24 104.44 167.57 103.77 167.57 103.02C167.57 101.63 166.45 100.51 165.06 100.51C163.67 100.51 162.55 101.63 162.55 103.02C162.55 103.71 162.83 104.34 163.28 104.79",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.569 103.02C168.959 103.02 170.079 101.9 170.079 100.51C170.079 99.12 168.959 98 167.569 98C166.179 98 165.06 99.12 165.06 100.51",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.4 98.1502C168.67 97.7502 168.829 97.2702 168.829 96.7502C168.829 95.3602 167.709 94.2402 166.319 94.2402C164.929 94.2402 163.81 95.3602 163.81 96.7502C163.81 97.7902 164.439 98.6802 165.339 99.0602",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.67 89.2202C123.67 98.2302 130.97 105.53 139.98 105.53C141.73 105.53 143.42 105.25 145 104.74C151.31 102.7 155.94 96.9202 156.27 90.0102C156.28 89.7502 156.29 89.4802 156.29 89.2202C156.29 80.2102 148.99 72.9102 139.98 72.9102C130.97 72.9202 123.67 80.2202 123.67 89.2202Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.48 91.1005C141.62 91.1005 140.84 90.5005 140.64 89.6305L138.13 78.3405C137.9 77.3305 138.54 76.3205 139.56 76.1005C140.57 75.8705 141.58 76.5105 141.8 77.5305L144.31 88.8205C144.54 89.8305 143.9 90.8405 142.88 91.0605C142.76 91.0905 142.62 91.1005 142.48 91.1005Z",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.01 96.1197C149.53 96.1197 149.05 95.9397 148.68 95.5697C147.95 94.8297 147.95 93.6397 148.68 92.9097L152.44 89.1497C153.18 88.4097 154.37 88.4097 155.1 89.1497C155.83 89.8797 155.83 91.0797 155.1 91.8097L151.34 95.5697C150.97 95.9397 150.49 96.1197 150.01 96.1197Z",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.449 86.0901H128.689C127.649 86.0901 126.81 85.2501 126.81 84.2101C126.81 83.1701 127.649 82.3301 128.689 82.3301H132.449C133.489 82.3301 134.329 83.1701 134.329 84.2101C134.329 85.2501 133.489 86.0901 132.449 86.0901Z",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.569 96.1206C129.529 96.1206 128.689 95.2806 128.689 94.2406V91.7306C128.689 90.6906 129.529 89.8506 130.569 89.8506C131.609 89.8506 132.449 90.6906 132.449 91.7306V94.2406C132.449 95.2806 131.609 96.1206 130.569 96.1206Z",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74 98.6297C143.46 98.6297 143.17 98.5697 142.9 98.4297L137.88 95.9197C136.95 95.4497 136.57 94.3297 137.04 93.3997C137.51 92.4697 138.63 92.0997 139.56 92.5597L144.58 95.0697C145.51 95.5397 145.89 96.6597 145.42 97.5897C145.09 98.2497 144.43 98.6297 143.74 98.6297Z",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 84.8306C146.46 84.8306 145.62 83.9905 145.62 82.9505V79.1906C145.62 78.1506 146.46 77.3105 147.5 77.3105C148.54 77.3105 149.38 78.1506 149.38 79.1906V82.9505C149.38 83.9905 148.54 84.8306 147.5 84.8306Z",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.98 103.651H136.22C135.18 103.651 134.34 102.811 134.34 101.771C134.34 100.731 135.18 99.8906 136.22 99.8906H139.98C141.02 99.8906 141.86 100.731 141.86 101.771C141.86 102.811 141.02 103.651 139.98 103.651Z",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.279 106.78L157.539 108.04",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.81 111.8L165.06 113.06",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.569 108.04H170.079",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.08 101.771L172.59 104.281",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.81 96.75H161.3",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.319 91.7305V94.2405",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54 115.57L160.05 116.82",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.27 110.55V111.8",
    stroke: "#91A7FF",
    strokeWidth: 1.0246,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.161 70.9105C115.201 71.2405 115.11 71.5905 114.88 71.8705C114.43 72.4405 113.611 72.5305 113.041 72.0805L110.38 69.9705C109.81 69.5205 109.721 68.7005 110.171 68.1305C110.621 67.5605 111.44 67.4705 112.01 67.9205L114.671 70.0305C114.961 70.2605 115.121 70.5805 115.161 70.9105Z",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.712 68.9668L198.135 73.3418L202.51 80.9193L210.087 76.5443L205.712 68.9668Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.05 97.5196C200.856 97.5196 201.51 96.8659 201.51 96.0596C201.51 95.2533 200.856 94.5996 200.05 94.5996C199.244 94.5996 198.59 95.2533 198.59 96.0596C198.59 96.8659 199.244 97.5196 200.05 97.5196Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.37 87.5695L174.28 79.5195",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8799 1.51953L56.5698 31.6095",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6001 8.19922L64.3701 22.6892",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.44 29.3809L183.61 37.1809",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceRightImage);
export default __webpack_public_path__ + "static/media/scienceRightImage.73549ea673cf2558c0a5f1f32ed2b163.svg";
export { ForwardRef as ReactComponent };